import { create } from "zustand";

interface HookProps {
  open: boolean;
  announcementId: string;
  setAnnouncementId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useDeleteAnnouncementModal = create<HookProps>()((set) => ({
  open: false,
  announcementId: "",
  setAnnouncementId: (id) =>
    set(() => ({
      announcementId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
